import type { InputLeadFieldInput, Query } from '~/schema/types/generated'
import type { IAdditionalMailFields } from '~/ts/interfaces/IAdditionalMailFields'
import { FORM_MUTATION } from '~/queries/PROMETHEUS/SEND_LEAD'

export function useLeadForm() {
    const route = useRoute()
    const config = useRuntimeConfig()
    const url = config.public.api.prometheus ?? '/api/hermes/graphql'

    const generateLeadID = (): string => {
        const newDate: Date = new Date()

        const id = [
            newDate.getMilliseconds(),
            newDate.getMinutes(),
            newDate.getHours(),
            newDate.getDate(),
            newDate.getMonth(),
            newDate.getFullYear(),
            Math.floor(Math.random() * 100 + 1),
        ]

        return id.join('-')
    }

    const formUpFields = () => [
        {
            name: 'utm_medium',
            value: localStorage.getItem('utm_medium') ?? 'null',
        },
        {
            name: 'utm_source',
            value: localStorage.getItem('utm_source') ?? 'null',
        },
        {
            name: 'utm_campaign',
            value: localStorage.getItem('utm_campaign') ?? 'null',
        },
        {
            name: 'utm_content',
            value: localStorage.getItem('utm_content') ?? 'null',
        },
        {
            name: 'utm_term',
            value: localStorage.getItem('utm_term') ?? 'null',
        },
        {
            name: 'adfcd',
            value: localStorage.getItem('adfcd') ?? 'null',
        },
        {
            name: 'dclid',
            value: localStorage.getItem('dclid') ?? 'null',
        },
        {
            name: 'gclid',
            value: localStorage.getItem('gclid') ?? 'null',
        },
    ]

    const parseBooleanToString = (item: InputLeadFieldInput): InputLeadFieldInput => ({
        name: item.name?.toString(),
        value: item.value ? `TAK<br>\n` : `NIE<br>\n`,
    })

    const normalizeString = (value: string): string => {
        return value?.toString()?.replace(/\s+/g, '').trim()
    }

    const prepareData = (inputData: IAdditionalMailFields): InputLeadFieldInput[] => {
        const formattedData = Object.entries(inputData).map(([key, value]) => {
            const normalizeValue = key.includes('NR') ? normalizeString(value) : value
            return { name: key, value: normalizeValue || '' }
        })

        formattedData.push({ name: 'LEAD_ID', value: generateLeadID() })
        formattedData.push({ name: 'FORM_URL', value: route.path })

        return [...formattedData, ...formUpFields()]
    }

    const sendLeadForm = async (
        additionalMailFields: IAdditionalMailFields,
        event_type = 'glcf',
        mail_title = 'www_global_lead',
    ) => {
        const formData = prepareData(additionalMailFields)
        const fields = formData
            .map((item: InputLeadFieldInput) => {
                if (!item.name || item.value === null) {
                    return null
                }

                let field: InputLeadFieldInput = {
                    name: item.name?.toString(),
                    value: `${item.value?.toString()}<br>\n`,
                }

                if (item.name?.toLowerCase().includes('zgoda')) {
                    field = parseBooleanToString(item)
                }

                return field.value && field.value.trim() !== '' && field.value !== '<br>\n' && field.value !== '<br>\n↵'
                    ? field
                    : null
            })
            .filter(Boolean)

        const { status, data, error } = await useLazyFetch<Query>(url, {
            method: 'POST',
            body: {
                query: FORM_MUTATION.loc?.source.body,
                variables: {
                    event_type,
                    mail_title,
                    fields,
                },
            },
        })

        return {
            pending: status.value === 'pending',
            success: !error.value && status.value !== 'pending',
            warning: !!error.value,
            resp: data.value,
        }
    }

    return { sendLeadForm }
}
